import { render, staticRenderFns } from "./HKLDownloadLink.vue?vue&type=template&id=16a5aaad&"
import script from "./HKLDownloadLink.vue?vue&type=script&lang=js&"
export * from "./HKLDownloadLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16a5aaad')) {
      api.createRecord('16a5aaad', component.options)
    } else {
      api.reload('16a5aaad', component.options)
    }
    module.hot.accept("./HKLDownloadLink.vue?vue&type=template&id=16a5aaad&", function () {
      api.rerender('16a5aaad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Upload/HKLDownloadLink.vue"
export default component.exports